import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { DataTableHeader } from "vuetify";
import draggable from "vuedraggable";

type Props = {
  value: any[];
  headers: DataTableHeader[];
};
type Emits = {
  (e: "input", val: any[]): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'DraggableTable',
  props: {
    value: null,
    headers: null
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", val: any[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: any[];
  headers: DataTableHeader[];
};




const modelValue = computed({
  get: () => props.value,
  set: val => emits("input", val)
});

return { __sfc: true,props, emits, modelValue, draggable }
}

})